import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ActivityFilter } from 'generated/graphql'
import Modal, { IFModalProps } from '@app.components/Modal/Modal'
import { ActivityTypeID } from 'constants/enums'
import { TActivityFilterStoreFilterBy } from '../store/slice/baseSlice'
import { useModalActivityFilterEffect } from './ModalActivityFilter.module'
import ActivityFilterBottom from './bottom'
import ActivityFilterMid from './mid'
import ActivityFilterTop from './top'

interface IFModalActivityFilterProps extends IFModalProps {
  activityTypeId: ActivityTypeID
  onSubmit: (filterBy: ActivityFilter) => void
  defaultFilterBy?: TActivityFilterStoreFilterBy
  className?: string
  filterType: 'calender' | 'activity'
}

const ModalActivityFilter: FC<IFModalActivityFilterProps> = ({
  activityTypeId,
  className,
  onClose,
  onSubmit,
  defaultFilterBy,
  open,
  filterType,
  ...modalProps
}) => {
  useModalActivityFilterEffect({
    activityTypeId,
    defaultFilterBy,
    open,
  })

  return (
    <StyledModal
      className={className}
      onClose={onClose}
      open={open}
      {...modalProps}
    >
      <div className="modal-top">
        <ActivityFilterTop
          onClose={() => {
            onClose && onClose()
          }}
        />
      </div>
      <ActivityFilterMid className="modal-mid" />
      <ActivityFilterBottom
        onSubmit={onSubmit}
        className="modal-bottom"
        filterType={filterType}
      />
    </StyledModal>
  )
}

export default ModalActivityFilter

const StyledModal = styled(Modal)`
  ${({ theme }) => css`
    position: fixed;
    z-index: 300;

    > .content {
      height: 100%;
      background-color: white;
      position: relative;
      overflow: auto;
    }

    > .dimmed {
      display: none;
    }

    .modal-top {
      position: sticky;
      top: 0;
      width: 100%;
      background-color: white;
      border-bottom: 1px solid ${theme.line.line_3};
      z-index: 3;
    }

    .modal-mid {
      margin-bottom: 81px;
      overflow-y: auto;
      transition: 0.2s margin-bottom;
    }

    :has(.selected-filter-list) .modal-mid {
      margin-bottom: 129px;
    }

    .modal-bottom {
      position: fixed;
      bottom: 0;
      background-color: white;
    }
  `}
`
